import { useCallback, useEffect, useState } from 'react';
import api from 'utils/api';
import { formatNumber } from 'utils/formatNumber';

const transformWallet = (raw) => ({
  balance: formatNumber(raw.balance, 0),
});

export const useWallet = () => {
  const [error, setError] = useState(null);
  const [data, setData] = useState({});
  const getData = useCallback(() => {
    api
      .get('/wallet/v1/profile', {
        session: true,
      })
      .then((res) => {
        if (res?.error) {
          if (res?.data?.error === 'token_expired') {
            window.location.href = '/logout';
          }
          if (res?.data?.error === 'unauthorized') {
            setTimeout(() => {
              window.location.href = '/logout';
            }, 3000);
          }
          setError(res?.data);
          return;
        }
        setData(transformWallet(res?.data));
      });
  }, [setData]);
  useEffect(() => {
    getData();
  }, [getData]);
  return [data, getData, error];
};

const transformBuy = (res, payload) => ({
  payment_url: res?.data?.url,
  items: [
    {
      label: `${formatNumber(payload?.amount, 0)} Gems`,
      amount: payload?.amount,
    },
  ],
  total_amount: formatNumber(payload?.amount),
});

export const useBuyWallet = () => {
  const [isLoading, setIsLoading] = useState(false);
  const submit = useCallback(
    (payload) =>
      new Promise((resolve) => {
        setIsLoading(true);
        api
          .post('/payment/v1/pgi/generate', {
            session: true,
            payload,
          })
          .then((res) => {
            setIsLoading(false);
            if (res?.error) resolve(res);
            resolve(transformBuy(res, payload));
          });
      }),
    [setIsLoading]
  );
  return [isLoading, submit];
};
